module.exports = __webpack_public_path__ + "static/media/AppIcon.fa919b4c.svg";